module.exports = "https://cdn.dove.it/_next/static/public/assets/services/home-staging_340x200.10a21ae985fb88f30dda396626e13d1e.png";